/* eslint-disable @typescript-eslint/no-explicit-any -- Работа с произвольным объектом */
/**
 * Функция для получения поля объекта по пути из полей объекта.
 *
 * @param obj Объект
 * @param path Путь из полей объекта
 * @typeParam ReturnValue Возвращаемое значение
 * @returns Значение внутри объекта по пути
 * @example
 * ```ts
 * const user = {
 *   profile: {
 *     name: 'John',
 *     address: {
 *       city: 'Moscow',
 *       street: 'Lenina'
 *     }
 *   }
 * };
 *
 * const city = get(user, ['profile', 'address', 'city']); // 'Moscow'
 * const street = get(user, ['profile', 'address', 'street']); // 'Lenina'
 * const missing = get(user, ['profile', 'age']); // undefined
 * ```
 */
export function get(obj, path) {
    let currentScope = obj;
    for (const part of path) {
        if (typeof currentScope?.hasOwnProperty === 'function' && currentScope.hasOwnProperty(part)) {
            currentScope = currentScope[part];
        }
        else {
            return;
        }
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return currentScope;
}
